export default "__VITE_ASSET__Bnt5$7MF__"